import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div``

export const Values = styled.div`
  ${tw`flex justify-between`}
`
